/**
 * @generated SignedSource<<b66d59fc2fb5b1b33aa1bf1b18cde790>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SettingsRegionEditPageQuery$variables = {
  after?: string | null;
  first: number;
  id: string;
  search?: string | null;
};
export type SettingsRegionEditPageQuery$data = {
  readonly region: {
    readonly country: {
      readonly id: string;
      readonly name: string;
    };
    readonly name: string;
    readonly " $fragmentSpreads": FragmentRefs<"RegionEditTabs_region" | "RegionSidebar_region">;
  } | null;
};
export type SettingsRegionEditPageQuery = {
  response: SettingsRegionEditPageQuery$data;
  variables: SettingsRegionEditPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Country",
  "kind": "LinkedField",
  "name": "country",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v5/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SettingsRegionEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Region",
        "kind": "LinkedField",
        "name": "region",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v7/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RegionEditTabs_region"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "RegionSidebar_region"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SettingsRegionEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "Region",
        "kind": "LinkedField",
        "name": "region",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v7/*: any*/),
          (v6/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "after",
                "variableName": "after"
              },
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
              },
              {
                "kind": "Variable",
                "name": "search",
                "variableName": "search"
              }
            ],
            "concreteType": "CityConnection",
            "kind": "LinkedField",
            "name": "cities",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CityEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "City",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "deletable",
                            "storageKey": null
                          }
                        ],
                        "type": "Entity",
                        "abstractKey": "__isEntity"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "total",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ClientExtension",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__id",
                    "storageKey": null
                  }
                ]
              }
            ],
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "220fc031c5f6f48da1ea5b4a0313c3e6",
    "id": null,
    "metadata": {},
    "name": "SettingsRegionEditPageQuery",
    "operationKind": "query",
    "text": "query SettingsRegionEditPageQuery(\n  $id: ID!\n  $search: String\n  $first: Int!\n  $after: String\n) {\n  region(id: $id) {\n    name\n    country {\n      id\n      name\n    }\n    ...RegionEditTabs_region\n    ...RegionSidebar_region\n    id\n  }\n}\n\nfragment AddCityDialog_region on Region {\n  id\n}\n\nfragment CityRow_city on City {\n  id\n  name\n  ...EntityTableRow_entity\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment EntityTableRow_entity on Entity {\n  __isEntity: __typename\n  id\n  deletable\n}\n\nfragment RegionEditCities_region on Region {\n  cities(first: $first, after: $after, search: $search) {\n    edges {\n      node {\n        id\n        ...CityRow_city\n      }\n    }\n    pageInfo {\n      ...Table_pageInfo\n    }\n  }\n  ...AddCityDialog_region\n  id\n}\n\nfragment RegionEditMain_region on Region {\n  id\n  name\n}\n\nfragment RegionEditTabs_region on Region {\n  ...RegionEditMain_region\n  ...RegionEditCities_region\n}\n\nfragment RegionSidebar_region on Region {\n  ...EntitySidebar_entity\n}\n\nfragment TablePagination_pageInfo on PageInfo {\n  total\n}\n\nfragment Table_pageInfo on PageInfo {\n  total\n  ...TablePagination_pageInfo\n}\n"
  }
};
})();

(node as any).hash = "44def48bfc4f552129b22ea0a2975241";

export default node;
